var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142.153,
    height: 114.712,
    viewBox: "0 0 142.153 114.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#208ce1;opacity:0.15;}.b,.e,.f,.g,.h,.i,.k{fill:none;}.b,.c,.e,.f,.g,.h,.i{stroke:#011d29;}.b,.h{stroke-linejoin:round;}.c{fill:#fff;}.d{fill:#e6e9ec;opacity:0.6;}.f,.g,.h{stroke-linecap:round;}.g{stroke-width:1.5px;}.i{stroke-width:2px;}.j{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1061.347 -344.11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20409.049-309.853H20384.6v19.011h65.01v-10.145h-35.191Z",
    transform: "translate(-19281.479 657.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20409.049-309.853H20384.6v56.683h65.01v-47.818h-35.191Z",
    transform: "translate(-19288.193 662.186)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(1121.678 379.674)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "j",
    cx: 28.5,
    cy: 29,
    rx: 28.5,
    ry: 29
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 28.5,
    cy: 29,
    rx: 28,
    ry: 28.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2,0h8.786a3,3,0,0,1,3,3V15.025a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
    transform: "matrix(0.891, -0.454, 0.454, 0.891, 1061.347, 416.505)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "d",
    cx: 46.975,
    cy: 9.5,
    rx: 46.975,
    ry: 9.5,
    transform: "translate(1092.729 439.821)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M20384.6-292.807h65.318",
    transform: "translate(-19288.193 664.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M20365.367-310.74v8.9",
    transform: "translate(-19290.271 662.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M20365.367-310.74v12.981",
    transform: "translate(-19175.357 655.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M0,0V8.9",
    transform: "translate(1079.547 355.801) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M0,0V12.983",
    transform: "translate(1196.5 351.348) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 1064.421, 413.213)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0V5.266H5.5",
    transform: "translate(11.316 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M16.484,20.4H0V0H11.5l4.988,4.99Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M20363.379-252.638l4.176-2.13",
    transform: "translate(-19293.84 668.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M20363.377-250.66l7.295-3.907",
    transform: "translate(-19291.559 671.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M20363.379-250.708l7.133-3.89",
    transform: "translate(-19289.227 675.689)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(1168.211 435.094) rotate(-43)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 12.188,
    height: 25.484,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 0.5,
    y: 0.5,
    width: 11.188,
    height: 24.484,
    rx: 5.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(1196.5 406.746)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 3.5,
    cy: 3.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 3.5,
    cy: 3.5,
    r: 3
  })), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(1125.678 382.674)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1126.766 385.544)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(-0.088 0.129)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "j",
    cx: 23.5,
    cy: 23,
    rx: 23.5,
    ry: 23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 23.5,
    cy: 23,
    rx: 23,
    ry: 22.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.461 13.406)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M20421-271.9l5.887,5.887",
    transform: "translate(-20421 271.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M20426.887-271.9l-5.887,5.887",
    transform: "translate(-20421 271.901)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.189 13.406)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M20421-271.9l5.887,5.887",
    transform: "translate(-20421 271.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M20426.887-271.9l-5.887,5.887",
    transform: "translate(-20421 271.901)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M20427.613-256.231s2.3-3.4,6.182-3.4a6.836,6.836,0,0,1,5.707,3.4",
    transform: "translate(-20410.313 287.74)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M20451.373-245.985l2.594,2.594",
    transform: "translate(-19280.666 674.759)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/Nodata.97d2d979160a9a68e557cacd09ee0095.svg";
export { ForwardRef as ReactComponent };